import { render, staticRenderFns } from "./ShippingRowsReadOnlyPanel.vue?vue&type=template&id=bc639574"
import script from "./ShippingRowsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./ShippingRowsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./ShippingRowsReadOnlyPanel.vue?vue&type=style&index=0&id=bc639574&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports